interface BandDetailModalProps {
  bandName: string;
  onClose: () => void;
}

const BandDetailModal = ({ bandName, onClose }: BandDetailModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="gradient-bg text-white p-6 rounded-t-xl">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-white text-xl font-bold mr-4">
                TR
              </div>
              <div>
                <h2 className="text-xl font-semibold">{bandName}</h2>
                <p className="opacity-90">ロック • 東京都 • 5人</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">📝</span>
                バンド概要
              </h3>
              <p className="text-gray-700 bg-gray-50 p-3 rounded-lg">
                週末中心の活動で、ライブハウスでの演奏を目指しています。メンバー同士の仲が良く、音楽を楽しみながら本格的な活動をしています。オリジナル楽曲の制作にも力を入れています。
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">🎯</span>
                活動目標
              </h3>
              <div className="flex flex-wrap gap-2">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                  ライブ活動
                </span>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
                  オリジナル制作
                </span>
                <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">
                  音楽配信
                </span>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">📅</span>
                活動スケジュール
              </h3>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>練習頻度</span>
                  <span className="font-medium">週2回</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>練習時間</span>
                  <span className="font-medium">19:00-22:00</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>次回ライブ</span>
                  <span className="font-medium text-blue-600">
                    3/15 渋谷CLUB
                  </span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">💰</span>
                費用・条件
              </h3>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>月会費</span>
                  <span className="font-medium">5,000円</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>スタジオ代</span>
                  <span className="font-medium">割り勘</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>年齢制限</span>
                  <span className="font-medium">20-35歳</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex space-x-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              閉じる
            </button>
            <button className="flex-1 gradient-bg text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity">
              メッセージを送る
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BandDetailModal;
